export function AlertWarn(props) {
    const show = props.show
    if (show) {
        return <div class="alert alert-warning" role="alert">{props.msg}</div>;
    }
    return "";
}

export function AlertDanger(props) {
    const show = props.show
    if (show) {
        return <div class="alert alert-danger" role="alert">{props.msg}</div>;
    }
    return "";
}

export function AlertMessage(props) {
    const show = props.show
    if (show) {
        return <div class="alert alert-primary" role="alert">{props.msg}</div>;
    }
    return "";
}